import { useEffect } from "react";

export const SEO = ({ title, description, jsonLd }) => {
  useEffect(() => {
    document.title = title;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", description);
    if (jsonLd) {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = "seo-jsonld";
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
    return () => {
      document.getElementById("seo-jsonld")?.remove();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, JSON.stringify(jsonLd || null)]);
  return null;
};

export const localBusinessJsonLd = {
  "@context": "https://schema.org",
  "@type": "HomeAndConstructionBusiness",
  name: "Gregory Tile & Home Remodeling",
  telephone: "+1-256-555-8453",
  email: "quotes@gregorytile.com",
  address: {
    "@type": "PostalAddress",
    addressLocality: "Huntsville",
    addressRegion: "AL",
    addressCountry: "US",
  },
  areaServed: [
    "Huntsville, AL",
    "Madison, AL",
    "Athens, AL",
    "Madison County, AL",
    "Limestone County, AL",
    "Morgan County, AL",
  ],
  priceRange: "$$",
};
